import { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';
import Menu from 'antd/lib/menu';

import { Switch, Route } from 'react-router-dom';

import { PageWrapper } from 'modules/layout';
import config from 'config/index';

import MapPage from '../../containers/MapPage';
import ImageMapsPage from '../../containers/ImageMapsPage';

import rule from './MapsPage.rule';

const MenuItems = {
    pins: 'pins',
    images: 'images',
};

const Links = {
    [MenuItems.pins]: config.routes.pins,
    [MenuItems.images]: config.routes.imageMaps,
};

const ReverseLinks = {
    [Links[MenuItems.pins]]: MenuItems.pins,
    [Links[MenuItems.images]]: MenuItems.images,
};

const routes = [
    {
        exact: false,
        path: config.routes.pins,
        render: () => <MapPage />,
    },
    {
        exact: false,
        path: config.routes.imageMaps,
        render: () => <ImageMapsPage />,
    },
];

const MapsPage = ({ history: { push }, location: { pathname } }) => {
    const { css } = useFela();
    return (
        <PageWrapper
            header={
                <Fragment>
                    <FormattedMessage id="maps.page.title" />
                </Fragment>
            }
        >
            <div className={css(rule)}>
                <Menu
                    onClick={e => {
                        push(Links[e.key]);
                    }}
                    mode="horizontal"
                    selectedKeys={[ReverseLinks[pathname]].filter(Boolean)}
                >
                    <Menu.Item key={MenuItems.pins}>
                        <FormattedMessage id="maps.page.menu.pins" />
                    </Menu.Item>
                    <Menu.Item key={MenuItems.images}>
                        <FormattedMessage id="maps.page.menu.images" />
                    </Menu.Item>
                </Menu>
                <Switch>
                    {routes.map(({ exact, path, render }) => (
                        <Route key={path} exact={exact} path={path} render={render} />
                    ))}
                </Switch>
            </div>
        </PageWrapper>
    );
};

MapsPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
};

export default MapsPage;
